import type { FC } from 'react';
import type { BoxProps } from '@mui/material';
import { Box, Typography } from '@mui/material';

import { numberOrDash } from 'src/helper/helper';

import { styles } from './index.styles';

interface CellWithBarProps extends BoxProps {
  percentage: number | null;
}

const CellWithBar: FC<CellWithBarProps> = ({ percentage, ...props }) => (
  <Box className="CellWithBar-root" sx={styles.cellWithBar} {...props}>
    <Typography className="CellWithBar-label" sx={styles.cellWithBarLabel}>
      {numberOrDash(percentage, true)}
    </Typography>

    <Box className="CellWithBar-barWrapper" sx={styles.cellWithBarBarWrapper}>
      <Box className="CellWithBar-bar" sx={styles.cellWithBarBar(percentage)} />
    </Box>
  </Box>
);
export default CellWithBar;
